/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/miami-instructions/miami-instructions.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import10 from '../../../../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import11 from '../../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import12 from '../../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import16 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import17 from '@angular/core/src/linker/element_ref';
import * as import18 from '@ngx-translate/core/src/translate.service';
import * as import19 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import20 from '@angular/forms/src/directives/control_value_accessor';
import * as import21 from '@angular/forms/src/directives/ng_model';
import * as import22 from '@angular/forms/src/directives/ng_control';
import * as import23 from '@angular/forms/src/directives/ng_control_status';
import * as import24 from '@angular/common/src/directives/ng_class';
import * as import25 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import26 from '../../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import27 from '../../../../../../../public/upgrade/feature/additionalPoint/phone-component/phone.container.component';
import * as import28 from '../../../additionalPoint/phone-component/phone.container.component.ngfactory';
import * as import29 from '@angular/core/src/linker/template_ref';
import * as import30 from '../../../../../../../public/upgrade/core/logger.service';
import * as import31 from '../../../../../../../public/upgrade/root/ga/ga.service';
import * as import32 from '@angular/common/src/directives/ng_for';
import * as import33 from '@angular/common/src/directives/ng_if';
export class Wrapper_MiamiInstructionsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.MiamiInstructionsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  constructor() {
    this._changed = false;
    this._changes = {};
    this.context = new import0.MiamiInstructionsComponent();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._changes['dto'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_countryId(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.countryId = currValue;
      this._changes['countryId'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_isValidLocation(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.isValidLocation = currValue;
      this._changes['isValidLocation'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_MiamiInstructionsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_MiamiInstructionsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.MiamiInstructionsComponent>;
  _MiamiInstructionsComponent_0_3:Wrapper_MiamiInstructionsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_MiamiInstructionsComponent_Host0,renderType_MiamiInstructionsComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'miami-instructions',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_MiamiInstructionsComponent0(this.viewUtils,this,0,this._el_0);
    this._MiamiInstructionsComponent_0_3 = new Wrapper_MiamiInstructionsComponent();
    this.compView_0.create(this._MiamiInstructionsComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._MiamiInstructionsComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.MiamiInstructionsComponent) && (0 === requestNodeIndex))) { return this._MiamiInstructionsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._MiamiInstructionsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._MiamiInstructionsComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const MiamiInstructionsComponentNgFactory:import8.ComponentFactory<import0.MiamiInstructionsComponent> = new import8.ComponentFactory<import0.MiamiInstructionsComponent>('miami-instructions',View_MiamiInstructionsComponent_Host0,import0.MiamiInstructionsComponent);
const styles_MiamiInstructionsComponent:any[] = ([] as any[]);
class View_MiamiInstructionsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import9.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _CheckboxControlValueAccessor_6_3:import10.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_6_4:any[];
  _NgModel_6_5:import11.Wrapper_NgModel;
  _NgControl_6_6:any;
  _NgControlStatus_6_7:import12.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _map_18:any;
  /*private*/ _expr_19:any;
  _pipe_translate_0:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_MiamiInstructionsComponent1,renderType_MiamiInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_18 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-1 -md-1 -sm-1 new-margin-plat'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','eva-3-checkbox -lg'),(null as any));
    this._NgClass_2_3 = new import9.Wrapper_NgClass(this.parentView.parentView.injectorGet(import15.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import16.KeyValueDiffers,this.parentView.parentIndex),new import17.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'label',new import3.InlineArray2(2,'class','checkbox-label eva-3-label-form -md'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'input',new import3.InlineArray4(4,'class','checkbox-tag','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_6_3 = new import10.Wrapper_CheckboxControlValueAccessor(this.renderer,new import17.ElementRef(this._el_6));
    this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
    this._NgModel_6_5 = new import11.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_6_4);
    this._NgControl_6_6 = this._NgModel_6_5.context;
    this._NgControlStatus_6_7 = new import12.Wrapper_NgControlStatus(this._NgControl_6_6);
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','checkbox-check eva-3-icon-checkmark -eva-3-mr-sm'),(null as any));
    this._text_9 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray8(8,'click',(null as any),'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_6));
    this._NgModel_6_5.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_6_3.context; }
    if (((token === import20.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_4; }
    if (((token === import21.NgModel) && (6 === requestNodeIndex))) { return this._NgModel_6_5.context; }
    if (((token === import22.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_6; }
    if (((token === import23.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_7.context; }
    if (((token === import24.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = 'eva-3-checkbox -lg';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_18(this.parentView.context.missedPositionsRCC);
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this._CheckboxControlValueAccessor_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_1_0:boolean = !this.parentView.context.isValidLocation;
    this._NgModel_6_5.check_isDisabled(currVal_6_1_0,throwOnChange,false);
    const currVal_6_1_1:any = this.context.$implicit.checked;
    this._NgModel_6_5.check_model(currVal_6_1_1,throwOnChange,false);
    this._NgModel_6_5.ngDoCheck(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.ngDoCheck(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.checkHost(this,this,this._el_6,throwOnChange);
    valUnwrapper.reset();
    const currVal_19:any = import3.inlineInterpolate(2,'\n                    ',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.PlatformSelect')),' ',this.context.$implicit.value,'\n                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_9,currVal_19);
      this._expr_19 = currVal_19;
    }
  }
  destroyInternal():void {
    this._NgModel_6_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._CheckboxControlValueAccessor_6_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.addCheckbox(this.context.$implicit,$event.target.checked)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.$implicit.checked = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_MiamiInstructionsComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_MiamiInstructionsComponent2,renderType_MiamiInstructionsComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content eva-3-validation-inline -invalid'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','content-invalid-inline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_7:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.PlatformValidation')),'\n    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_7,currVal_7))) {
      this.renderer.setText(this._text_5,currVal_7);
      this._expr_7 = currVal_7;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_MiamiInstructionsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_MiamiInstructionsComponent,{});
export class View_MiamiInstructionsComponent0 extends import2.AppView<import0.MiamiInstructionsComponent> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _anchor_13:any;
  /*private*/ _vc_13:import14.ViewContainer;
  _TemplateRef_13_5:any;
  _NgFor_13_6:import25.Wrapper_NgFor;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _vc_17:import14.ViewContainer;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import26.Wrapper_NgIf;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  compView_20:import2.AppView<import27.PhoneContainerComponent>;
  _PhoneContainerComponent_20_3:import28.Wrapper_PhoneContainerComponent;
  _text_21:any;
  _text_22:any;
  /*private*/ _expr_31:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_33:any;
  _pipe_translate_1:import13.TranslatePipe;
  /*private*/ _expr_35:any;
  _pipe_translate_2:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_MiamiInstructionsComponent0,renderType_MiamiInstructionsComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_31 = import1.UNINITIALIZED;
    this._expr_33 = import1.UNINITIALIZED;
    this._expr_35 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','sara-reva-eva-3-subtitle-1 title-special-airport'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._text_2 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,parentRenderNode,'h6',new import3.InlineArray2(2,'class','sara-reva-eva-3-overline-1 subtitle-size font-weight-normal'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,parentRenderNode,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_9,'div',new import3.InlineArray2(2,'class','eva-3-row flex-container'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._anchor_13 = this.renderer.createTemplateAnchor(this._el_11,(null as any));
    this._vc_13 = new import14.ViewContainer(13,11,this,this._anchor_13);
    this._TemplateRef_13_5 = new import29.TemplateRef_(this,13,this._anchor_13);
    this._NgFor_13_6 = new import25.Wrapper_NgFor(this._vc_13.vcRef,this._TemplateRef_13_5,this.parentView.injectorGet(import15.IterableDiffers,this.parentIndex),this.ref);
    this._text_14 = this.renderer.createText(this._el_11,'\n    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_9,'\n',(null as any));
    this._text_16 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_17 = new import14.ViewContainer(17,(null as any),this,this._anchor_17);
    this._TemplateRef_17_5 = new import29.TemplateRef_(this,17,this._anchor_17);
    this._NgIf_17_6 = new import26.Wrapper_NgIf(this._vc_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_19 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,parentRenderNode,'phone-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_20 = new import28.View_PhoneContainerComponent0(this.viewUtils,this,20,this._el_20);
    this._PhoneContainerComponent_20_3 = new import28.Wrapper_PhoneContainerComponent(this.parentView.injectorGet(import30.LoggerService,this.parentIndex),this.parentView.injectorGet(import31.GAService,this.parentIndex));
    this._text_21 = this.renderer.createText((null as any),'\n',(null as any));
    this.compView_20.create(this._PhoneContainerComponent_20_3.context);
    this._text_22 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import13.TranslatePipe(this.parentView.injectorGet(import18.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_20));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._anchor_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import29.TemplateRef) && (13 === requestNodeIndex))) { return this._TemplateRef_13_5; }
    if (((token === import32.NgFor) && (13 === requestNodeIndex))) { return this._NgFor_13_6.context; }
    if (((token === import29.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import33.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    if (((token === import27.PhoneContainerComponent) && ((20 <= requestNodeIndex) && (requestNodeIndex <= 21)))) { return this._PhoneContainerComponent_20_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_13_0_0:any = this.context.platforms;
    this._NgFor_13_6.check_ngForOf(currVal_13_0_0,throwOnChange,false);
    this._NgFor_13_6.ngDoCheck(this,this._anchor_13,throwOnChange);
    const currVal_17_0_0:any = this.context.missedPositionsRCC;
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.ngDoCheck(this,this._anchor_17,throwOnChange);
    const currVal_20_0_0:any = this.context.errors;
    this._PhoneContainerComponent_20_3.check_errors(currVal_20_0_0,throwOnChange,false);
    const currVal_20_0_1:any = this.context.dto;
    this._PhoneContainerComponent_20_3.check_dto(currVal_20_0_1,throwOnChange,false);
    const currVal_20_0_2:any = this.context.countryId;
    this._PhoneContainerComponent_20_3.check_countryId(currVal_20_0_2,throwOnChange,false);
    const currVal_20_0_3:any = true;
    this._PhoneContainerComponent_20_3.check_hasOtherDeliveryMessage(currVal_20_0_3,throwOnChange,false);
    const currVal_20_0_4:any = this.context.PHONE_PREFIX;
    this._PhoneContainerComponent_20_3.check_phonePrefix(currVal_20_0_4,throwOnChange,false);
    const currVal_20_0_5:any = this.context.FREE_LINE;
    this._PhoneContainerComponent_20_3.check_freeLine(currVal_20_0_5,throwOnChange,false);
    const currVal_20_0_6:any = this.context.isValidLocation;
    this._PhoneContainerComponent_20_3.check_isValidLocation(currVal_20_0_6,throwOnChange,false);
    this._PhoneContainerComponent_20_3.ngDoCheck(this,this._el_20,throwOnChange);
    this._vc_13.detectChangesInNestedViews(throwOnChange);
    this._vc_17.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_31:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.Instructions')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_31,currVal_31))) {
      this.renderer.setText(this._text_1,currVal_31);
      this._expr_31 = currVal_31;
    }
    valUnwrapper.reset();
    const currVal_33:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('pickupPoint.RCCPlatform')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_33,currVal_33))) {
      this.renderer.setText(this._text_4,currVal_33);
      this._expr_33 = currVal_33;
    }
    valUnwrapper.reset();
    const currVal_35:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('pickupPoint.RCCPlatformInstructions')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_35,currVal_35))) {
      this.renderer.setText(this._text_7,currVal_35);
      this._expr_35 = currVal_35;
    }
    this.compView_20.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._PhoneContainerComponent_20_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_13.destroyNestedViews();
    this._vc_17.destroyNestedViews();
    this.compView_20.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 13)) { return new View_MiamiInstructionsComponent1(this.viewUtils,this,13,this._anchor_13,this._vc_13); }
    if ((nodeIndex == 17)) { return new View_MiamiInstructionsComponent2(this.viewUtils,this,17,this._anchor_17,this._vc_17); }
    return (null as any);
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/delivery-instructions/miami-instructions/miami-instructions.component.ngfactory.ts